<template>
    <crud-facecade
        ref="sys_doc_list"
        :url="url2"
        :columns="columnList2"
        :tableHeight="tableHeight"
        v-wechat-title="title"
        :addButton="{ permission: 'default' }"
        :deleteButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
        @deleteDocConfigMethod="deleteDocConfigMethod"
    >
    </crud-facecade>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `DocumentConfgSystem`,
    data() {
        return {
            title: `系统文书`,
            list: [],
            list2: [],
            activeName: `first`
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`ward_auth`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        url2() {
            return {
                baseURL: ``,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/DocConfig/Get`)
                        req.then(data => {
                            this.list2 = _.orderBy(data, `display_order`)
                            resolve(data)
                        })
                    })
                },
                post: data => {
                    return new Promise(resolve => {
                        data.is_allow_edit = 1
                        let req = this.myaxios.post(`/api/AcisSystem/DocConfig/Post`, data)
                        req.then(res => {
                            this.$refs.sys_doc_list.ReloadListData()
                            resolve(res)
                        })
                    })
                },
                putMany: (rows) => {
                    let reqs = rows.map(d => {
                        let oldrow = _.find(this.list2, { key: d.key })
                        let newrow = Object.assign({}, oldrow, d)
                        return this.myaxios[newrow.id ? `put` : `post`](`/api/AcisSystem/DocConfig/${newrow.id ? `put` : `post`}`, newrow)
                    })
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.all(...reqs)
                        req.then(res => {
                            this.$message.success(`保存成功`)
                            resolve()
                        }).catch(e => { reject(e) })
                    })
                }
            }
        },
        doc_types() {
            return this.sys_enums.EnumDocType
        },
        columnList2() {
            let list = [{
                type: `string`,
                prop: `id`,
                label: `id`,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                isExpand: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `120`,
                isListable: true,
                readonly: true
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                readonly: false
            }, {
                type: `string`,
                prop: `doc_id`,
                label: `文书编号`,
                isListable: true,
                readonly: false
            }, {
                type: `string`,
                prop: `default_printer_name`,
                label: `默认打印机名称`,
                isListable: true,
                readonly: false
            }, {
                type: `string`,
                prop: `default_printer_name_by_ward`,
                label: `区域配置默认打印机名称`,
                isListable: true,
                readonly: false
            }, {
                type: `bool`,
                prop: `score_many_times`,
                label: `多次评分`,
                width: `80`,
                isListable: true,
                isExpand: false,
                options: `enum_bool`,
                default: false,
                readonly: (that, { row }) => {
                    return !(row.doc_type == 2)
                }
            }, {
                type: `bool`,
                prop: `is_enable`,
                label: `是否启用`,
                width: `80`,
                isListable: true,
                isExpand: false,
                options: `enum_bool`,
                default: false,
                readonly: false
            }, {
                type: `select`,
                prop: `doc_type`,
                label: `文书类型`,
                width: `120`,
                isListable: true,
                options: this.doc_types,
                readonly: false,
                change: (that, { row }) => {
                    if (row.doc_type != 2) {
                        row.score_many_times = null
                    }
                }
            }, {
                type: `multiselect`,
                prop: `doc_ptype`,
                label: `适用人群`,
                width: `120`,
                isListable: true,
                default: 1,
                options: [{ label: `通用`, value: -1 }, { label: `儿童`, value: 0 }, { label: `成人(男)`, value: 1 }, { label: `成人(女)`, value: 2 }, { label: `老年`, value: 3 }],
                readonly: false
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `80`,
                fixed: `right`,
                config: {
                    align: `flex-start`
                },
                isListable: true,
                readonly: false,
                options: function(that, { row }) {
                    if (row.is_allow_edit === true) {
                        return [{
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `primary`,
                            emit: `deleteDocConfigMethod`,
                            permission: `default`
                        }]
                    }
                }

            }
            ]
            let createC = [{
                type: `string`,
                prop: `id`,
                label: `id`
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `120`,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `doc_id`,
                label: `文书编号`,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `bool`,
                prop: `score_many_times2`,
                label: `多次评分`,
                width: `80`,
                isCreatable: true,
                options: `enum_bool`,
                default: false,
                readonly: (that, { row }) => {
                    return !(row.doc_type == 2)
                }
            }, {
                type: `bool`,
                prop: `is_enable`,
                label: `是否启用`,
                width: `80`,
                isCreatable: true,
                options: `enum_bool`,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                default: true
            }, {
                type: `select`,
                prop: `doc_type`,
                label: `文书类型`,
                width: `120`,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                options: this.doc_types,
                change: (that, { row }) => {
                    if (row.doc_type != 2) {
                        row.score_many_times = null
                    }
                }
            }
            ]
            return list.concat(createC)
        }
    },
    methods: {
        deleteDocConfigMethod({ row, index }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                let req = this.myaxios.delete(`/api/AcisSystem/DocConfig/Delete/${row && row.id}`)
                req.then(data => {
                    this.$refs.sys_doc_list.ReloadListData()
                }).catch(e => {
                    console.log(e)
                })
            })
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Document/Index.vue